import Axios, { AxiosResponse } from "axios";

/**
 * NOTE: This is purposefully an "unauthorized" call because this is used outside of
 * authentication (places like share).
 * @returns list of categories
 */
export async function getCategories() {
    try {
        const response: AxiosResponse = await Axios.get("/services/gps/Category");
        return response.data;
    } catch (error) {
        throw error;
    }
}
